"use client";
import { sampleEvents, appEvent } from "../sampleData/sampleEventsData";

import { createContext, ReactNode, useState } from "react";

interface EventsContextType {
  events: appEvent[];
  setEvents: React.Dispatch<React.SetStateAction<appEvent[]>>;
}

interface EventsContextType {
  events: appEvent[];
  setEvents: React.Dispatch<React.SetStateAction<appEvent[]>>;
}

// 1. Creating context
export const EventsContext = createContext<EventsContextType>({
  events: [],
  setEvents: () => {},
});

// 2. Providing context
export const EventsProvider = ({ children }: { children: ReactNode }) => {

  const [events, setEvents] = useState<appEvent[]>(sampleEvents);

  return(
    // And in EventsProvider, change value to:
    <EventsContext.Provider value={{ events, setEvents }}>
      {children}
    </EventsContext.Provider>
  );
}; 